/**
 * @voltxampere/ui — Hobby solar panel 5V/100mA (Sprint 51-1 polish)
 *
 * Generic polycrystalline silicon solar panel — typical hobby grade
 * for educational projects, IoT prototyping. Open-circuit voltage
 * 5V at full sun, 100mA short-circuit. Used in solar-charger demos,
 * outdoor sensor nodes.
 *
 * Modeled as voltage-source with 100Ω internal resistance (rough
 * approximation — real cells are nonlinear V/I curves).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sourceSolarPanel = {
    id: "solar-panel-5v",
    nameTr: "Güneş Paneli 5V/100mA (Hobby)",
    nameEn: "Solar Panel 5V/100mA (Hobby)",
    shortcut: "S",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "PV",
    defaultValue: "5V/100mA",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 5,
        chemistry: "polycrystalline-Si",
        openCircuitV: 5,
        shortCircuitMa: 100,
        internalResistanceOhm: 50,
        typicalEfficiencyPercent: 18,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=source-solar-panel.js.map